import React from 'react';
import { DatePicker } from '@oneaudi/unified-web-alpha-components';
import { useDispatch, useSelector } from 'react-redux';
import { DateSelectorWrapper } from './DateSelector.styles';
import { selectInputs, setUserInputs } from '../../../redux/inputsReducer';

interface DateSelectorTypes {
  inputKey: string;
}

const DateSelector: React.FC<DateSelectorTypes> = ({ inputKey }) => {
  const dispatch = useDispatch();

  const inputs = useSelector(selectInputs);
  const dateValue = inputs[inputKey] || '';

  const onHandleChange = (value: string) => {
    dispatch(setUserInputs({ inputName: inputKey, inputValue: value }));
  };
  return (
    <DateSelectorWrapper>
      <DatePicker
        // appendix="*"
        data-testid="date-picker"
        errorMessage="Please, select the correct date"
        id="date-picker"
        label="Please select a date in the calendar"
        onChange={(e) => {
          onHandleChange(e.target.value);
        }}
        onClick={() => {}}
        value={dateValue}
      />
    </DateSelectorWrapper>
  );
};

export default DateSelector;
